module.exports = __webpack_public_path__ + "img/hero_employee_.4683ef5b.svg";